import { createContext, useContext, useState } from "react";
import { visualisationDefaults } from 'src/data';

const TripMapContext = createContext();

export const TripMapProvider = ({ children }) => {
  const [visualisation, setVisualisation] = useState(null);
  const [animationDuration, setAnimationDuration] = useState(visualisationDefaults.animationDuration);
  const [mapStyle, setMapStyle] = useState(visualisationDefaults.mapStyle);
  const [lineColor, setLineColor] = useState(visualisationDefaults.lineColor);
  const [distanceUnit, setDistanceUnit] = useState(visualisationDefaults.distanceUnit);
  const [pitch, setPitch] = useState(visualisationDefaults.pitch);

  const triggerVisualisation = (slug) => setVisualisation(slug);

  const updateVisualisation = (updates) =>
    setVisualisation((prev) => ({ ...prev, ...updates }));

  const clearVisualisation = () => setVisualisation(null);

  return (
    <TripMapContext.Provider
      value={{ 
        visualisation, 
        triggerVisualisation, 
        updateVisualisation, 
        clearVisualisation,
        animationDuration,
        setAnimationDuration,
        mapStyle,
        setMapStyle,
        lineColor,
        setLineColor,
        distanceUnit,
        setDistanceUnit,
        pitch,
        setPitch
      }}>

      {children}

    </TripMapContext.Provider>
  );
};

export const useTripMap = () => useContext(TripMapContext);

